<div class="rank-order-container">
  @if (props.label) {
    <label
      class="section w-100"
      [class.mat-error]="
        formControl.errors && formControl.touched && this.ordered.length <= 0
      "
      ><span tabindex="0" [innerHTML]="props.label"></span>
      @if (props.required) {
        <sup>*</sup>
      }
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
    </label>
  }
  @if (props.prompt) {
    <p
      class="explanation"
      [class.mat-error]="
        formControl.errors && formControl.touched && this.ordered.length <= 0
      "
    >
      <span tabindex="0" [innerHTML]="props.prompt"></span>
      @if (props.help && !to.label && !to.placeholder) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
    </p>
  }
  @if (props.placeholder) {
    <p
      class="italic"
      [class.mat-error]="
        formControl.errors && formControl.touched && this.ordered.length <= 0
      "
    >
      <span tabindex="0" [innerHTML]="props.placeholder"></span>
      @if (props.required && !to.label) {
        <span> *</span>
      }
      @if (props.help && !to.label && !to.prompt) {
        <mat-icon
          matTooltip="{{ to.help }}"
          class="help-icon"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          help
        </mat-icon>
      }
    </p>
  }
  <div class="rank-order-component">
    <div
      class="list-container"
      [class.mat-error]="
        formControl.errors && formControl.touched && this.ordered.length <= 0
      "
    >
      <h5>Unranked</h5>

      <div
        #unorderedList="cdkDropList"
        cdkDropList
        class="list unranked"
        [cdkDropListData]="unordered"
        [cdkDropListConnectedTo]="[orderedList]"
        (cdkDropListDropped)="drop($event)"
      >
        @for (item of unordered; track item.value) {
          <div class="list-item-box" cdkDrag>
            <span class="list-item-name">
              <mat-icon class="me-2">drag_handle</mat-icon>
              {{ item.label }}
            </span>
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="Add to ranked list"
              (click)="addItem(item)"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>

    <div
      class="list-container"
      [class.mat-error]="
        formControl.errors && formControl.touched && this.ordered.length <= 0
      "
    >
      <h5>Ranked</h5>

      <div
        #orderedList="cdkDropList"
        cdkDropList
        class="list"
        [cdkDropListData]="ordered"
        [cdkDropListConnectedTo]="[unorderedList]"
        (cdkDropListDropped)="drop($event)"
      >
        @if (ordered.length === 0) {
          <p>Drag & order options here.</p>
        }
        @for (item of ordered; track item.value; let idx = $index) {
          <div class="list-item-box" cdkDrag>
            <span class="list-item-name">
              <span class="ranking me-2"> ({{ idx + 1 }}) </span>
              {{ item.label }}
            </span>
            <button
              type="button"
              mat-icon-button
              color="warn"
              matTooltip="Remove Annuity"
              (click)="removeItem(item)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
